export default __webpack_public_path__ + "static/media/login_logo.a3393507.png";